import React from 'react';
import Button from '../../../components/Button';

interface EmptyProjectsViewProps {
  onFindLocation: () => void;
}

const EmptyProjectsView: React.FC<EmptyProjectsViewProps> = ({ onFindLocation }) => {
  return (
    <div style={{ 
      padding: '1.5rem', 
      backgroundColor: '#fff', 
      borderRadius: '8px',
      textAlign: 'center',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
    }}>
      <p style={{ 
        marginBottom: '1.5rem',
        fontSize: '1rem',
        lineHeight: 1.5,
        color: '#333'
      }}>
        You haven't created any projects yet. Click "Find a Business Location" to get started.
      </p>
      <Button 
        onClick={onFindLocation}
        style={{
          padding: '0.75rem 1.5rem',
          fontSize: '1rem',
          width: '100%',
          maxWidth: '300px'
        }}
      >
        Find a Business Location
      </Button>
    </div>
  );
};

export default EmptyProjectsView;
